import { useState, useEffect } from 'react'
import axios from 'axios'

const useGetSupportTable = (type) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    const response = await axios.get(`/support-tables/for-select/${type}`)
    setOptions(response.data || [])
  }

  return options
}

export default useGetSupportTable
